import { cisaAsset } from './CISA/asset';
import { defaultAsset } from './default/asset';

export const getAssets = {
  cisa: cisaAsset,
  default: defaultAsset,
};
